<div class="main-content mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a class="btn btn-dark btn-sm btn-new" [routerLink]="['/marketing']">
            Keywords
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/offPageCampaigns/urlMapping']"
          >
            URL Mapping
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/onPage']"
          >
            On-Page
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/internalLinks/add']"
          >
            Internal Links
          </a>
        </div>
      </div>
    </div>

    <div class="row pb-3">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/technicalQa']"
          >
            Technical QA
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/localSeo']"
          >
            Local SEO
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/offPage']"
          >
            Off-Page
          </a>
          <a class="btn btn-dark btn-sm btn-reg"> Performance </a>
        </div>
      </div>
    </div>
    <div class="performance-container p-4" *ngIf="!loading">
      <!-- ── HEADER ─────────────────────────────────────────────────────── -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 class="h4 mb-0 fw-bold">SEO Performance Command Center</h2>
          <!-- <p class="text-muted mb-0 small">
            Observe. Compare. Interpret. Detect. Signal. Drive the right SEO
            decisions.
          </p> -->
        </div>
        <div class="d-flex gap-2">
          <!-- <button class="btn btn-outline-secondary btn-sm p-1 btn-header">
            <i class="fas fa-info-circle me-1"></i> How it works
          </button> -->
          <button class="btn btn-outline-secondary btn-sm p-1 btn-header">
            <i class="fas fa-download me-1"></i> Export Report
          </button>
          <!-- <button class="btn btn-sm btn-add p-1 btn-header">
            <i class="fas fa-plus me-1"></i> New Monitoring Request
          </button> -->
        </div>
      </div>

      <!-- ── FILTERS ────────────────────────────────────────────────────── -->
      <div class="row">
        <div class="col-3">
          <label class="text-dark" for="urlMapping"
            ><strong>Performance Scope</strong></label
          >
        </div>
        <div class="col-9 d-flex justify-content-end mt-2">
          <button
            class="btn btn-outline-secondary btn-sm btn-filter"
            (click)="onFilterChange()"
          >
            Find
          </button>
        </div>
      </div>
      <div class="row mb-0 px-3 flex-nowrap">
        <!-- City -->
        <div class="col mb-0 filter-card">
          <label class="form-label small fw-bold text-dark mb-1 d-block"
            >City</label
          >
          <select
            class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
            [(ngModel)]="pendingCity"
          >
            <option *ngFor="let c of cities" [value]="c.value">
              {{ c.label }}
            </option>
          </select>
        </div>

        <!-- Universe -->
        <div class="col mb-0 filter-card">
          <label class="form-label small fw-bold text-dark mb-1 d-block"
            >Universe</label
          >
          <select
            class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
            [(ngModel)]="pendingUniverse"
          >
            <option *ngFor="let u of universes" [value]="u.value">
              {{ u.label }}
            </option>
          </select>
        </div>

        <!-- Category -->
        <div class="col mb-0 filter-card">
          <label class="form-label small fw-bold text-dark mb-1 d-block"
            >Category</label
          >
          <select
            class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
            [(ngModel)]="pendingCategory"
          >
            <option *ngFor="let c of categories" [value]="c.value">
              {{ c.label }}
            </option>
          </select>
        </div>

        <!-- Date Range -->
        <div class="col mb-0 filter-card">
          <label class="form-label small fw-bold text-dark mb-1 d-block"
            >Date Range</label
          >
          <select
            class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
            [(ngModel)]="pendingDateRange"
          >
            <option *ngFor="let d of dateRanges" [value]="d.value">
              {{ d.label }}
            </option>
          </select>
        </div>

        <!-- Channel -->
        <div class="col mb-0 filter-card">
          <label class="form-label small fw-bold text-dark mb-1 d-block"
            >Channel</label
          >
          <select
            class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
            [(ngModel)]="pendingChannel"
          >
            <option *ngFor="let c of channels" [value]="c.value">
              {{ c.label }}
            </option>
          </select>
        </div>

        <!-- Campaign -->
        <div class="col mb-0 filter-card">
          <label class="form-label small fw-bold text-dark mb-1 d-block"
            >Campaign</label
          >
          <select
            class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
            [(ngModel)]="pendingCampaign"
          >
            <option *ngFor="let c of campaigns" [value]="c.value">
              {{ c.label }}
            </option>
          </select>
        </div>

        <!-- URL -->
        <div class="col mb-0 filter-card">
          <label class="form-label small fw-bold text-dark mb-1 d-block"
            >URL</label
          >
          <select
            class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
            [(ngModel)]="pendingUrl"
          >
            <option *ngFor="let u of urls" [value]="u.value">
              {{ u.label }}
            </option>
          </select>
        </div>
      </div>

      <!-- ── STATS CARDS ────────────────────────────────────────────────── style="min-width: 175px-->
      <div class="row">
        <div class="col-12">
          <div
            class="row m-0 align-items-stretch flex-nowrap custom-scroll-x p-0 gap-3"
          >
            <div
              class="col p-0 pr-1 d-flex"
              *ngFor="
                let stat of [
                  {
                    key: 'Total Keywords Tracked',
                    data: stats.trackedKeywords,
                  },
                  { key: 'Keywords Up', data: stats.keywordsUp },
                  { key: 'Keywords Down', data: stats.keywordsDown },
                  { key: 'Average Position', data: stats.avgPosition },
                  { key: 'Organic Clicks', data: stats.organicClicks },
                  { key: 'Quote Requests', data: stats.quoteRequests },
                  { key: 'Bookings', data: stats.bookings },
                  { key: 'SEO Revenue Estimate', data: stats.revenueEstimate },
                ]
              "
            >
              <div class="card shadow-sm border-0 bg-white w-100">
                <div class="card-body px-1 py-1 d-flex">
                  <div class="stat-icon-filled {{ stat.data.bg }} me-3">
                    <i class="{{ stat.data.icon }}"></i>
                  </div>
                  <div class="space-cards">
                    <div
                      class="text-uppercase fw-bold text-dark mb-1"
                      style="font-size: 0.63rem; letter-spacing: 0.5px"
                    >
                      <strong>{{ stat.key }}</strong>
                    </div>
                    <h3 class="mb-1 fw-bold text-dark">
                      <strong>{{ stat.data.value }}</strong>
                    </h3>
                    <div class="small fw-medium {{ stat.data.trendColor }}">
                      <i
                        class="{{
                          stat.data.arrow === 'down'
                            ? 'fas fa-arrow-down'
                            : 'fas fa-arrow-up'
                        }}"
                      ></i>
                      {{ stat.data.trend }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ── ROW 1 ──────────────────────────────────────────────────────── -->
      <div class="row">
        <!-- Top Gaining Keywords -->
        <div class="col-6 mb-0 pr-0 d-flex">
          <div class="card shadow-sm border-0 mt-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 pb-0 pt-3 d-flex justify-content-between align-items-center text-sm"
            >
              <h4 class="fw-bold text-dark mb-0">
                <strong>Top Gaining Keywords</strong>
              </h4>
              <i class="fas fa-info-circle ms-1 text-muted small pl-1"></i>
              <a
                href="#"
                class="text-primary text-decoration-none small fw-semibold"
                >View all</a
              >
            </div>
            <div class="card-body p-0 pt-2">
              <div class="table-responsive">
                <table
                  class="table table-borderless table-sm small align-middle mb-0 text-center"
                >
                  <thead class="text-dark border-bottom">
                    <tr>
                      <th class="text-start ps-3 fw-semibold head-table">
                        <strong>Keyword</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>URL</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>Prev. Rank</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>Rank</strong>
                      </th>
                      <th class="pe-3 fw-semibold head-table">
                        <strong>Change</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of topGaining" class="border-bottom">
                      <td class="text-start ps-3 fw-semibold text-dark">
                        {{ item.keyword }}
                      </td>
                      <td class="text-muted">{{ item.url }}</td>
                      <td class="text-dark">{{ item.prev }}</td>
                      <td class="text-dark fw-bold">{{ item.curr }}</td>
                      <td class="pe-3 text-success fw-bold">
                        <i class="fas fa-arrow-up me-1"></i>{{ item.change }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Top Losing Keywords -->
        <div class="col-6 mb-0 d-flex">
          <div class="card shadow-sm border-0 mt-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 pb-0 pt-3 d-flex justify-content-between align-items-center text-sm"
            >
              <h4 class="fw-bold text-dark mb-0">
                <strong>Top Losing Keywords</strong>
              </h4>
              <i class="fas fa-info-circle ms-1 text-muted small pl-1"></i>
              <a
                href="#"
                class="text-primary text-decoration-none small fw-semibold"
                >View all</a
              >
            </div>
            <div class="card-body p-0 pt-2">
              <div class="table-responsive">
                <table
                  class="table table-borderless table-sm small align-middle mb-0 text-center"
                >
                  <thead class="text-dark border-bottom">
                    <tr>
                      <th class="text-start ps-3 fw-semibold head-table">
                        <strong>Keyword</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>Primary URL</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>Prev. Rank</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>Rank</strong>
                      </th>
                      <th class="pe-3 fw-semibold head-table">
                        <strong>Change</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of topLosing" class="border-bottom">
                      <td class="text-start ps-3 fw-semibold text-dark">
                        {{ item.keyword }}
                      </td>
                      <td class="text-muted">{{ item.url }}</td>
                      <td class="text-dark">{{ item.prev }}</td>
                      <td class="text-dark fw-bold">{{ item.curr }}</td>
                      <td class="pe-3 text-danger fw-bold">
                        <i class="fas fa-arrow-down me-1"></i
                        >{{ item.change * -1 }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ── ROW 2 ──────────────────────────────────────────────────────── -->
      <div class="row">
        <!-- URL Performance -->
        <div class="col-6 mb-0 pr-0 d-flex">
          <div class="card shadow-sm border-0 mt-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 pb-0 pt-3 d-flex justify-content-between align-items-center text-sm"
            >
              <h4 class="fw-bold text-dark mb-0">
                <strong>URL Performance</strong>
                <i class="fas fa-info-circle ms-1 text-muted small pl-1"></i>
              </h4>
              <a
                href="#"
                class="text-primary text-decoration-none small fw-semibold"
                >View full report ></a
              >
            </div>
            <div class="card-body p-0 pt-2">
              <div class="table-responsive">
                <table
                  class="table table-borderless table-sm small align-middle mb-0 text-center"
                >
                  <thead class="text-dark border-bottom">
                    <tr>
                      <th class="text-start ps-3 fw-semibold head-table">
                        <strong>URL</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>Keywords</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>Avg. Position</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>Clicks</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>Conversions</strong>
                      </th>
                      <th class="pe-3 fw-semibold head-table">
                        <strong>Status</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let item of urlPerformance"
                      class="border-bottom"
                    >
                      <td class="text-start ps-3 fw-semibold text-dark">
                        {{ item.url }}
                      </td>
                      <td class="text-dark">{{ item.keywords }}</td>
                      <td class="text-dark">{{ item.pos }}</td>
                      <td class="text-dark">{{ item.clicks }}</td>
                      <td class="text-dark">{{ item.conv }}</td>
                      <td class="pe-3">
                        <span
                          class="badge rounded-pill text-transformNone {{
                            item.badge
                          }} p-1 px-2"
                          >{{ item.status }}</span
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Conversion Performance -->
        <div class="col-6 mb-0 pr-0 d-flex">
          <div class="card shadow-sm border-0 mt-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 pb-0 pt-3 d-flex justify-content-between align-items-center text-sm"
            >
              <h4 class="fw-bold text-dark mb-0">
                <strong>Conversion Performance</strong>
                <i class="fas fa-info-circle ms-1 text-muted small pl-1"></i>
              </h4>
              <a
                href="#"
                class="text-primary text-decoration-none small fw-semibold"
                >View full report ></a
              >
            </div>
            <div class="card-body p-0 pt-2 d-flex flex-column">
              <div class="table-responsive flex-grow-1">
                <table
                  class="table table-borderless table-sm small align-middle mb-0 text-center"
                >
                  <thead class="text-dark border-bottom">
                    <tr>
                      <th class="text-start ps-3 fw-semibold head-table">
                        <strong>Category</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>Clicks</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>Quote Requests</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>Bookings</strong>
                      </th>
                      <th class="pe-3 fw-semibold head-table">
                        <strong>Conversion Rate</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let item of conversionPerformance"
                      class="border-bottom"
                    >
                      <td class="text-start ps-3 fw-semibold text-dark">
                        {{ item.cat }}
                      </td>
                      <td class="text-dark">{{ item.clicks }}</td>
                      <td class="text-dark">{{ item.quotes }}</td>
                      <td class="text-dark">{{ item.bookings }}</td>
                      <td
                        class="pe-3 font-weight-bold"
                        [ngClass]="item.rate < 3 ? 'text-danger' : 'text-dark'"
                      >
                        {{ item.rate }}%
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="p-3">
                <div
                  class="bg-warning-light border border-warning rounded p-2 d-flex align-items-start gap-2"
                >
                  <i class="fas fa-exclamation-triangle text-warning mt-1"></i>
                  <div>
                    <strong class="text-dark d-block" style="font-size: 0.8rem"
                      >Courier Services has traffic but weak conversion.</strong
                    >
                    <span class="text-muted" style="font-size: 0.75rem"
                      >Recommended action: review CTA, title, meta description,
                      and booking path.</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ── ROW 3 ──────────────────────────────────────────────────────── -->
      <div class="row">
        <!-- City Performance -->
        <div class="col-6 mb-0 d-flex pr-0">
          <div class="card shadow-sm border-0 mt-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 pb-0 pt-3 d-flex justify-content-between align-items-center text-sm"
            >
              <h4 class="fw-bold text-dark mb-0">
                <strong>City Performance</strong>
                <i class="fas fa-info-circle ms-1 text-muted small pl-1"></i>
              </h4>
              <a
                href="#"
                class="text-primary text-decoration-none small fw-semibold"
                >View full report ></a
              >
            </div>
            <div class="card-body p-0 pt-2">
              <div class="table-responsive">
                <table
                  class="table table-borderless table-sm small align-middle mb-0 text-center"
                >
                  <thead class="text-dark border-bottom">
                    <tr>
                      <th class="text-start ps-3 fw-semibold head-table">
                        <strong>City</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>Keywords</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>Avg. Position</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>Clicks</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>Bookings</strong>
                      </th>
                      <th class="pe-3 fw-semibold head-table">
                        <strong>Trend</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let item of cityPerformance"
                      class="border-bottom"
                    >
                      <td class="text-start ps-3 fw-semibold text-dark">
                        {{ item.city }}
                      </td>
                      <td class="text-dark">{{ item.keywords }}</td>
                      <td class="text-dark">{{ item.pos }}</td>
                      <td class="text-dark">{{ item.clicks }}</td>
                      <td class="text-dark">{{ item.bookings }}</td>
                      <td class="pe-3">
                        <i
                          class="fas"
                          [ngClass]="{
                            'fa-arrow-up text-success': item.trend === 'up',
                            'fa-arrow-down text-danger': item.trend === 'down',
                            'fa-arrow-right text-info': item.trend === 'right',
                          }"
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- SEO Health Summary -->
        <div class="col-6 mb-0 pr-0 d-flex">
          <div class="card shadow-sm border-0 mt-0 flex-grow-1">
            <div class="card-body p-3">
              <h4 class="fw-bold text-dark mb-3 d-flex align-items-center">
                <strong>SEO Health Summary</strong>
                <i class="fas fa-info-circle ms-1 text-muted small pl-1"></i>
              </h4>
              <ul class="list-unstyled mb-0 d-flex flex-column gap-3 small">
                <li
                  *ngFor="let item of healthSummary"
                  class="d-flex align-items-start"
                >
                  <i class="mt-1 me-2" [ngClass]="item.icon"></i>
                  <span class="text-dark pl-1">{{ item.text }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- ── ROW 4 ──────────────────────────────────────────────────────── -->
      <div class="row">
        <!-- Competitive Movement -->
        <div class="col-4 mb-0 pr-0 d-flex">
          <div class="card shadow-sm border-0 mt-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 pb-0 pt-3 d-flex justify-content-between align-items-center text-sm"
            >
              <h4 class="fw-bold text-dark mb-0">
                <strong>Competitive Movement</strong>
                <i class="fas fa-info-circle ms-1 text-muted small pl-1"></i>
              </h4>
              <a
                href="#"
                class="text-primary text-decoration-none small fw-semibold"
                >View full report ></a
              >
            </div>
            <div class="card-body p-0 pt-2 d-flex flex-column">
              <div class="table-responsive">
                <table
                  class="table table-borderless table-sm small align-middle mb-0 text-center"
                >
                  <thead class="text-dark border-bottom">
                    <tr>
                      <th class="text-start ps-3 fw-semibold head-table">
                        <strong>Competitor</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>Shared Keywords</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>They Gained</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>We Gained</strong>
                      </th>
                      <th class="pe-3 fw-semibold head-table">
                        <strong>Risk</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let item of competitiveMovement"
                      class="border-bottom"
                    >
                      <td class="text-start ps-3 fw-semibold text-dark">
                        {{ item.comp }}
                      </td>
                      <td class="text-dark">{{ item.shared }}</td>
                      <td class="text-dark">{{ item.gained }}</td>
                      <td class="text-dark">{{ item.weGained }}</td>
                      <td class="pe-3">
                        <span
                          class="badge rounded-pill text-transformNone {{
                            item.badge
                          }} px-2 p-1"
                          >{{ item.risk }}</span
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="p-3">
                <div
                  class="bg-primary-light border border-primary rounded p-2 d-flex align-items-start gap-2"
                >
                  <i
                    class="fas fa-info-square text-primary mt-1"
                    style="font-size: 1rem"
                  ></i>
                  <div>
                    <strong class="text-dark d-block" style="font-size: 0.8rem"
                      >Company A is gaining visibility in Same-Day Courier and
                      Legal Courier terms.</strong
                    >
                    <span class="text-muted" style="font-size: 0.75rem"
                      >Recommendation: strengthen /same-day-courier/ and
                      /legal-services/ with internal links and off-page
                      authority actions.</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Performance Findings -->
        <div class="col-4 mb-0 pr-0 d-flex">
          <div class="card shadow-sm border-0 mt-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 pb-0 pt-3 d-flex justify-content-between align-items-center text-sm"
            >
              <h4 class="fw-bold text-dark mb-0">
                <strong>Performance Findings (Alerts)</strong>
                <i class="fas fa-info-circle ms-1 text-muted small pl-1"></i>
              </h4>
              <a
                href="#"
                class="text-primary text-decoration-none small fw-semibold"
                >View full report ></a
              >
            </div>
            <div class="card-body p-3 pt-2">
              <ul class="list-unstyled mb-0 d-flex flex-column gap-3 small">
                <li
                  *ngFor="let item of performanceFindings"
                  class="d-flex align-items-center justify-content-between border-bottom pb-2"
                >
                  <div class="d-flex align-items-center gap-2">
                    <i [ngClass]="item.icon" class="text-{{ item.type }}"></i>
                    <span class="text-dark fw-semibold pl-1">{{
                      item.text
                    }}</span>
                  </div>
                  <div>
                    <span
                      class="badge rounded-pill text-transformNone {{
                        item.badgeClass
                      }} p-1 px-2"
                      >{{ item.badge }}</span
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Recommended Specialist Reviews -->
        <div class="col-4 mb-0 d-flex">
          <div class="card shadow-sm border-0 mt-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 pb-0 pt-3 d-flex justify-content-between align-items-center text-sm"
            >
              <h4 class="fw-bold text-dark mb-0">
                <strong>Recommended Specialist Reviews</strong>
                <i class="fas fa-info-circle ms-1 text-muted small pl-1"></i>
              </h4>
              <a
                href="#"
                class="text-primary text-decoration-none small fw-semibold"
                >View all signals ></a
              >
            </div>
            <div class="card-body p-0 pt-2">
              <div class="table-responsive">
                <table
                  class="table table-borderless table-sm small align-middle mb-0 text-center"
                >
                  <thead class="text-dark border-bottom">
                    <tr>
                      <th class="text-start ps-3 fw-semibold head-table">
                        <strong>Finding / Opportunity</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>Owner Module</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>Priority</strong>
                      </th>
                      <th class="pe-3 fw-semibold text-start head-table">
                        <strong>Reason</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let item of specialistReviews"
                      class="border-bottom"
                    >
                      <td
                        class="text-start ps-3 fw-semibold text-dark"
                        style="max-width: 140px; text-wrap: wrap"
                      >
                        {{ item.finding }}
                      </td>
                      <td class="fw-semibold {{ item.moduleClass }}">
                        {{ item.module }}
                      </td>
                      <td>
                        <span
                          class="badge rounded-pill text-transformNone"
                          [ngClass]="
                            item.priority === 'High'
                              ? 'bg-danger-light text-danger'
                              : 'bg-warning-light text-warning'
                          "
                          >{{ item.priority }}</span
                        >
                      </td>
                      <td
                        class="pe-3 text-start text-muted"
                        style="max-width: 120px; text-wrap: wrap"
                      >
                        {{ item.reason }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ── ROW 5 ──────────────────────────────────────────────────────── -->
      <div class="row">
        <!-- Active Monitoring -->
        <div class="col-8 pr-0 d-flex">
          <div class="card shadow-sm border-0 mt-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 pb-0 pt-3 d-flex justify-content-between align-items-center text-sm"
            >
              <h4 class="fw-bold text-dark mb-0">
                <strong>Active Monitoring (Changes Being Observed)</strong>
                <i class="fas fa-info-circle ms-1 text-muted small pl-1"></i>
              </h4>
              <a
                href="#"
                class="text-primary text-decoration-none small fw-semibold"
                >View all monitoring ></a
              >
            </div>
            <div class="card-body p-0 pt-2">
              <div class="table-responsive">
                <table
                  class="table table-borderless table-sm small align-middle mb-0 text-center"
                >
                  <thead class="text-dark border-bottom">
                    <tr>
                      <th class="text-start ps-3 fw-semibold head-table">
                        <strong>Origin Module</strong>
                      </th>
                      <th class="text-start fw-semibold head-table">
                        <strong>Change Implemented</strong>
                      </th>
                      <th class="text-start fw-semibold head-table">
                        <strong>Target</strong>
                      </th>
                      <th class="text-start fw-semibold head-table">
                        <strong>Expected Behavior</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>Start Date</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>Observation Window</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>Status</strong>
                      </th>
                      <th class="pe-3 fw-semibold text-start head-table">
                        <strong>Progress</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let item of activeMonitoring"
                      class="border-bottom"
                    >
                      <td class="text-start ps-3 fw-bold text-dark">
                        {{ item.module }}
                      </td>
                      <td class="text-start text-dark fw-semibold">
                        {{ item.change }}
                      </td>
                      <td class="text-start text-primary fw-medium">
                        {{ item.target }}
                      </td>
                      <td class="text-start text-dark">{{ item.expected }}</td>
                      <td class="text-muted">{{ item.start }}</td>
                      <td class="text-dark">{{ item.window }}</td>
                      <td class="fw-semibold text-dark">{{ item.status }}</td>
                      <td class="pe-3 text-start">
                        <div
                          class="progress mb-0"
                          style="height: 6px; width: 40px"
                        >
                          <div
                            class="progress-bar bg-primary"
                            role="progressbar"
                            [style.width]="item.progress + '%'"
                          ></div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Recent Performance Activity -->
        <div class="col-4 d-flex">
          <div class="card shadow-sm border-0 mt-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 pb-0 pt-3 d-flex justify-content-between align-items-center text-sm"
            >
              <h4 class="fw-bold text-dark mb-0">
                <strong>Recent Performance Activity</strong>
                <i class="fas fa-info-circle ms-1 text-muted small"></i>
              </h4>
              <a
                href="#"
                class="text-primary text-decoration-none small fw-semibold"
                >View all activity ></a
              >
            </div>
            <div class="card-body p-0 pt-2">
              <div class="table-responsive">
                <table
                  class="table table-borderless table-sm small align-middle mb-0 text-center"
                >
                  <thead class="text-dark border-bottom">
                    <tr>
                      <th class="text-start ps-3 fw-semibold head-table">
                        <strong>Activity</strong>
                      </th>
                      <th class="text-start fw-semibold head-table">
                        <strong>Details</strong>
                      </th>
                      <th class="fw-semibold head-table">
                        <strong>By</strong>
                      </th>
                      <th class="pe-3 fw-semibold head-table">
                        <strong>Date</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let item of recentActivity"
                      class="border-bottom"
                    >
                      <td
                        class="text-start ps-3 fw-bold text-dark"
                        style="max-width: 100px; text-wrap: wrap"
                      >
                        {{ item.activity }}
                      </td>
                      <td
                        class="text-start text-muted"
                        style="max-width: 120px; text-wrap: wrap"
                      >
                        {{ item.details }}
                      </td>
                      <td class="text-dark">{{ item.by }}</td>
                      <td class="pe-3 text-dark">{{ item.date }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
